module.exports = __webpack_public_path__ + "static/img/logo.3eb579f8.png";